import { render, staticRenderFns } from "./correlation.vue?vue&type=template&id=3015ce4c&scoped=true"
import script from "./correlation.vue?vue&type=script&lang=js"
export * from "./correlation.vue?vue&type=script&lang=js"
import style0 from "./correlation.vue?vue&type=style&index=0&id=3015ce4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3015ce4c",
  null
  
)

export default component.exports